import { EventEmitter, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonConstant } from '../constants/common.constant';
import { ApiModulesService } from '../services/api-modules.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private count = 0;
  private spinner$ = new BehaviorSubject<string>('');
private _sidebarLogo = new BehaviorSubject<string>(null);
private _loginInfo = new BehaviorSubject<any>(null);
  constructor(private router: Router,private toastr: ToastrService,private apiModulesService: ApiModulesService) { }
  getSpinnerObserver(): Observable<string> {
    return this.spinner$.asObservable();
  }
  requestStarted() {
    if (++this.count === 1) {
      this.spinner$.next('start');
    }
  }
  requestEnded() {
    if (this.count === 0 || --this.count === 0) {
      this.spinner$.next('stop');
    }
  }
  resetSpinner() {
    this.count = 0;
    this.spinner$.next('stop');
  }
  dataemitterr = new EventEmitter<any>();
  raiseDataEmitterEvent(data: any) {
    this.dataemitterr.next(data);
  }
  toasterError(err: any) {
  this.raiseDataEmitterEvent('off');
  if (err?.status == 401) {
    let params: any = {};
    params.token = localStorage.getItem('token');
    this.apiModulesService.list('logout', params).subscribe();
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('is_first_login');
    window.localStorage.clear();
    ($('#logout_pop_up') as any).modal('hide');
    this.router.navigateByUrl("/login");
    return;
  }
  let errorMessage = 'Something went wrong';
  if (typeof err === 'string') {
    errorMessage = err;
  }
  else if (err?.code && err?.message) {
    errorMessage = err.message;
  }
  else if (err?.error?.data) {
    let errorsData = err.error.data;
    let firstKey = Object.keys(errorsData)[0];
    let errors = errorsData[firstKey];
    if (typeof errors === 'string') {
      errors = errors.replace('SQLSTATE[42000]: [Microsoft][ODBC Driver 17 for SQL Server][SQL Server]','Error: ');
      errors = errors.replace('SQLSTATE[42000]: [Microsoft][ODBC Driver 18 for SQL Server][SQL Server]','Error: ');
    }
    errorMessage = errors;
  }
  else if (err?.error?.message) {
    errorMessage = err.error.message;
  }
  else if (err?.message) {
    errorMessage = err.message;
  }
  this.toastr.error(errorMessage, 'TryAgain');
}
  leaveapplyemitterr = new EventEmitter<any>();
  compOffEmitterEvent(data: any) {
    this.leaveapplyemitterr.next(data);
  }
  getSeverity(status: string) {
    switch (status.toLowerCase()) {
      case 'inactive':
        return 'danger';
      case 'active':
        return 'success';
    }
  }
  getAcronym(str: any) {
    var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    matches = matches.slice(0, 2);
    var acronym = matches.join(''); // JSON
    return acronym;
  }
  getBgColors(str: any) {
    var min = 0;
    var max = 15;
    var index = this.findAlphapositions(str, 1);
    return CommonConstant.nameBgColors[index];
  }
  findAlphapositions(str: any, n: any) {
    var NUM = 31;
    return str[0].charCodeAt(0) & NUM;
  }
  callStatusModel(url_name: any, data: any) {
    var statusApi = url_name;
    var statusValue = data;
  }
get sidebarLogo(): Observable<string> {
  return this._sidebarLogo.asObservable();
}
get loginInfo(): Observable<any> {
  return this._loginInfo.asObservable();
}
setSidebarLogo(imageUrl: string) {
  this._sidebarLogo.next(imageUrl);
}
setLoginInfo(loginInfo: any) {
  this._loginInfo.next(loginInfo);
}
}
